import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionStateService } from '../../core/user/session-state.service';
import { UserService } from '../../core';

@Component({
    templateUrl: './access-denied.component.html',
    //styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {

    errorMessages: string[] = null;

    /** Construct */
    constructor(private userSvc: UserService,
        private router: Router,
        private sessionState: SessionStateService) {
    }

    ngOnInit(): void {
        console.log('Access denied.  Logging user out.')
        this.sessionState.prepareForUser(null);
        this.userSvc.logout()
            .then()
            .catch(ex => this.errorMessages = [ex.toString()]);
    }
}
